import React from 'react';
import styled from '@emotion/styled';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StyledLabel = styled.label`
  margin-left: 6px;

  &:hover {
    cursor: pointer;
  }
`;

type CheckboxProps = {
  id: string;
  label?: React.ReactNode;
  value?: string;
  defaultChecked?: boolean;
  disabled?: boolean;
  required?: boolean;
  onChange(name: string, value: string, checked: boolean): void;
};

export const Checkbox: React.FC<CheckboxProps> = ({
  id,
  label,
  value,
  defaultChecked,
  disabled,
  required,
  onChange,
}) => {
  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    onChange(event.target.name, event.target.value, event.target.checked);
  };

  return (
    <Wrapper>
      <input
        type="checkbox"
        id={id}
        name={id}
        value={value}
        defaultChecked={defaultChecked}
        disabled={disabled}
        required={required}
        onChange={handleOnChange}
      />
      {label ? <StyledLabel htmlFor={id}>{label}</StyledLabel> : null}
    </Wrapper>
  );
};
